exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image img {\n  max-height: 100% !important; }\n\n.media-content {\n  -ms-flex-item-align: center;\n      -ms-grid-row-align: center;\n      align-self: center; }\n\n.media {\n  cursor: pointer; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /mnt/d/Projects/angular/chisparural-foro/src/app/activity/notification-item/notification-item.component.scss
// module id = ../../../../../src/app/activity/notification-item/notification-item.component.scss
// module chunks = 1